import { createPlatform } from '@/platform/impl';
import type { PlatformServices } from './types';

export type * from './types';

let services: PlatformServices | undefined;

/**
 * `@/platform/impl` resolves to platform/web or platform/native at build time (vite.config.ts), so the web
 * bundle never contains Capacitor (its modules register plugins on import and cannot be tree-shaken).
 */
export function getPlatform(): PlatformServices {
  services ??= createPlatform();
  return services;
}
